import { isNil, uniqBy } from 'lodash'
import React, { useRef } from 'react'
import { connect } from 'react-redux'
import { expandLeftToolbar } from '../../../action/left-toolbar-state-actions'
import { collapseLeftToolbar } from '../../../action/left-toolbar-state-actions'
import { resolveTrackColor, trackPolylineOptions } from '../../../lib/trackColor'
import { contentVisibilityKey } from '../../../action/hidden-content-ids-actions'
import { visibleActiveVendors } from '../../../lib/layerVisibility'

const safeParseJSON = (jsonString) => {
  try {
    const fixedJsonString = jsonString
      .replace(/:\s*Infinity/g, ': null')  // Replace `Infinity` with `null`
      .replace(/:\s*-Infinity/g, ': null'); // Replace `-Infinity` with `null`

    let parsedData = JSON.parse(fixedJsonString);
    return parsedData; // Apply rounding
  } catch (error) {
    console.error("Error parsing JSON:", error);
    return null;
  }
};


const RenderTracks = (props) => {
  const { tracks, mapReference, expandLeftToolbar, activeVendors, vendors, collapseLeftToolbar, hiddenContentTypes, hiddenContentIds } = props
  // Remember the polyline drawn for each track id so a replaced track object (e.g.
  // after a save + changes sync, which swaps in a fresh object without mapObj) doesn't
  // leave its old line orphaned on the map under the newly-drawn one.
  const drawnRef = useRef(new Map())
  if (mapReference === null) {
    return null
  }

  // My Content per-type show/hide. When tracks are hidden, remove each user
  // track's polyline and clear its mapObj so the diff below re-draws it when
  // shown again. Vendor tracks are not My Content and are unaffected.
  const hideTracks = hiddenContentTypes.includes('tracks')
  // A track is hidden when its whole type is hidden (WEB-7044) or it is
  // individually hidden via "Hide on Map" (WEB-7047).
  const isTrackHidden = (track) => hideTracks || hiddenContentIds.includes(contentVisibilityKey('track', track.id))
  tracks.forEach(track => {
    if (!isTrackHidden(track)) return
    const drawn = drawnRef.current.get(track.id)
    if (drawn) { try { drawn.setMap(null) } catch (e) { /* already gone */ } drawnRef.current.delete(track.id) }
    if (track.mapObj) { try { track.mapObj().setMap(null) } catch (e) { /* already gone */ } track.mapObj = null }
  })

  const vendorTracks = activeVendors.map(id => {
    return vendors[id] && vendors[id]['tracks'] && vendors[id]['objects']['tracks'] ?
      vendors[id]['objects']['tracks'].filter(track => isNil(track.mapObj) && !isNil(track.geoJson)) : []
  }),
    toAdd = (hideTracks ? [] : tracks.filter(track => isNil(track.mapObj) && !isTrackHidden(track))).concat(vendorTracks.flat())
  if (toAdd.length > 0) {
    toAdd.forEach(track => {
      track['measureType'] = 'track'
      if (!track.geoJson) {
        return
      }

      // const geoJson = JSON.parse(track.geoJson),
      const geoJson = track?.geoJson && safeParseJSON(track.geoJson);
      if (!geoJson) {
        // console.error("Invalid geoJson:", track.geoJson);
      }
      // Drop any previously-drawn polyline for this track id before redrawing, so a
      // stale line (old color/style) can't linger beneath the new one.
      const prevMapTrack = drawnRef.current.get(track.id)
      if (prevMapTrack) {
        try { prevMapTrack.setMap(null) } catch (e) { /* already gone */ }
        drawnRef.current.delete(track.id)
      }

      const line = geoJson?.features?.[0]?.properties?.line || {},
        style = trackPolylineOptions(resolveTrackColor(line), line.style || 'solid', line.width),
        path = uniqBy(geoJson?.features[0]?.geometry?.coordinates, '0'),
        coords = path.map(coord => new google.maps.LatLng(coord[1], coord[0])),
        mapTrack = new google.maps.Polyline({
          name: track.name,
          map: mapReference,
          path: coords,
          zIndex: 10,
          ...style,
          options: {
            draggable: false,
            clickable: true,
            cursor: 'pointer'
          },
          metadata: {
            id: track.id,
            type: 'tracks'
          }
        })
      track['mapObj'] = function () { return mapTrack }
      drawnRef.current.set(track.id, mapTrack)
      mapTrack.addListener('click', () => {
        collapseLeftToolbar()
        expandLeftToolbar({ dialog: 'edit', editable: track })
      })
    })
  }
  return null
}

const mapStateToProps = state => ({
  // Hidden by the global layers eye toggle along with the layers they came from (WEB-7048).
  activeVendors: visibleActiveVendors(state),
  vendors: state.vendors,
  mapReference: typeof state.mapReference === 'function' ? state.mapReference() : null,
  tracks: state.tracks,
  hiddenContentTypes: state.hiddenContentTypes,
  hiddenContentIds: state.hiddenContentIds
})

const mapDispatchToProps = dispatch => ({
  expandLeftToolbar: props => dispatch(expandLeftToolbar(props)),
  collapseLeftToolbar: () => dispatch(collapseLeftToolbar()),
})

export default connect(mapStateToProps, mapDispatchToProps)(RenderTracks)